import { projectSelector } from "@rflocal/shared";
import { AnalyticsAbstractAdapter } from "./abstract";
import { AnalyticsMethod, AnalyticsEventData } from "../types";

/**
 * Segment analytics adapter.
 */
export class SegmentAnalyticsAdapter extends AnalyticsAbstractAdapter {
    // ignore page events since segment handles them differently
    protected readonly enabledMethods: AnalyticsMethod[] = Object.values(AnalyticsMethod).filter(
        (m) => m !== AnalyticsMethod.PAGE
    );

    // override ONLY if you need special behaviour
    protected postEvent({
        method,
        id,
        data
    }: {
        method: AnalyticsMethod;
        id?: string;
        data: AnalyticsEventData;
    }) {
        const args: any[] = [];
        if (id) args.push(id);

        args.push(data);

        // short-circuit for localhost / dev
        if (projectSelector.isLocal()) {
            console.log(`🧷 [Analytics] ${this.adapterName}`, method, args[0], args.slice(1));
            return;
        }

        // Defensive wrapper to catch DOM manipulation errors from third-party scripts
        try {
            return window.analytics?.[method](...args);
        } catch (error) {
            // Log the error but don't let analytics failures break the app
            console.warn(`[Analytics] ${this.adapterName} ${method} failed:`, error);
            // Return undefined to maintain consistent behavior
            return undefined;
        }
    }
}
